class MainArticle extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);

    this.rawUrl = window.location.href;
    this.fmtUrl = this.rawUrl.endsWith("/")
      ? this.rawUrl.slice(0, -1)
      : this.rawUrl;
    this.url = encodeURIComponent(this.fmtUrl);
    this.title = encodeURIComponent(document.title);
  }

  connectedCallback() {
    document.addEventListener("click", this.onClick, false);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this.onClick, false);
  }

  openPopup(link) {
    const top = Math.max(0, Math.round(window.innerHeight / 2 - 150));
    const left = Math.max(0, Math.round(window.innerWidth / 2 - 300));
    window.open(
      link,
      "",
      `menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600,top=${top},left=${left}`
    );
  }

  async handleCopy(buttonEl) {
    try {
      await navigator.clipboard.writeText(this.fmtUrl);

      const sr = buttonEl.querySelector(".sr-only");
      if (!sr) return;

      const prev = sr.textContent;
      sr.textContent = "Copied";
      window.setTimeout(() => {
        sr.textContent = prev || "Copy";
      }, 1500);
    } catch (e) {
      console.warn("[main-article] copy failed", e);
    }
  }

  onClick(event) {
    const btn = event.target.closest("button");
    if (!btn) return;

    if (!this.contains(btn)) return;

    if (btn.hasAttribute("data-share-facebook")) {
      const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.url}`;
      this.openPopup(fbUrl);
      return;
    }

    if (btn.hasAttribute("data-share-x")) {
      const xUrl = `https://twitter.com/intent/tweet?url=${this.url}&text=${this.title}`;
      this.openPopup(xUrl);
      return;
    }

    if (btn.hasAttribute("data-copy")) {
      this.handleCopy(btn);
    }
  }
}

customElements.define("main-article", MainArticle);
